enum EConnectSearchFilterMode {
  All = 'All',
  AppointmentsOnly = 'AppointmentsOnly',
  ClassesOnly = 'ClassesOnly'
}

export default EConnectSearchFilterMode;
